import { gql } from '@apollo/client';

const schema = {
  get: {
    name: "users",
    serviceName: "unitadmin",
    query: gql`
      query users($ids: [String]) {
        users(ids: $ids) {
          data {
            all_roles {
              status
              is_demo
              units {
                id
                title
              }
              labs {
                id
                title
              }
              role {
                id
                title
              }
            }
          }
        }
      }
    `,
  },
  delete: {
    name: "revokeUserRole",
    serviceName: "labadmin",
    query: gql`
      mutation revokeUserRole(
        $user_id: String!
        $role_id: String!
        $lab_id: String!
      ) {
        revokeUserRole(user_id: $user_id, role_id: $role_id, lab_id: $lab_id) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
